// 9fbef606107a605d69c0edbcd8029e5d
/* stylelint-disable no-descending-specificity */
import styled from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

const getCarouselArrowIcon = (props) =>
  props && props?.isCategoryTab ? getIconPath('smallright') : getIconPath('carousel-big-carrot');

export const StyledCarousel = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  .carousel-arrows {
    position: relative;
    height: auto;
    display: inline-flex;
    align-items: center;
    button {
      position: absolute;
    }
    .left-arrow {
      background: url(${(props) => getCarouselArrowIcon(props)}) no-repeat center center;
      outline: none;
      height: 40px;
      width: 18px;
      border: none;
      cursor: pointer;
      left: -21px;
      transform: rotate(180deg);
      display: none;
      @media ${(props) => props.theme.mediaQuery.large} {
        display: block;
      }
    }
    .right-arrow {
      background: url(${(props) => getCarouselArrowIcon(props)}) no-repeat center center;
      outline: none;
      height: 40px;
      width: 18px;
      border: none;
      cursor: pointer;
      right: -28px;
      display: none;
      @media ${(props) => props.theme.mediaQuery.large} {
        display: block;
      }
    }
  }
`;

export const StyledScroll = styled.div`
  margin: 0px;
  display: flex;
  overflow-x: scroll;
  scroll-behavior: smooth;
  height: 100%;
  overflow-y: hidden;
  white-space: nowrap;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
export const StyledGrid = styled.div`
  height: 100%;
  display: flex;
  ${(props) =>
    props.isCategoryTab
      ? `
  justify-content: space-between;
  `
      : `gap: ${props.theme.spacing.ELEM_SPACING.SM};`}
  button {
    ${(props) =>
      props.isCategoryTab
        ? `
    text-transform: none;
    padding: 0 ${props.theme.spacing.ELEM_SPACING.SM};`
        : ''}
  }
`;
